import { Box, Button, Typography } from "@material-ui/core";
import leftArrow from "../../../assets/icons/leftArrow.png";
import "./MobileReadingPaneBanner.css";
import Shiitake from "shiitake";

interface ScreenProps {
  pageTitle: string;
  onClose: () => Promise<void>;
}

export default function MobileReadingPaneBanner(props: ScreenProps) {
  return (
    <Box height="40px" className="mobileTopBanner">
      <div className="topLeftText">
        <Button onClick={props.onClose} style={{ padding: 0, width: "30px" }}>
          <img className="leftArrow" alt="Return Home" src={leftArrow} />
        </Button>
        <Typography className="headerTextLeft" component="div">
          <Shiitake lines={2}>{props.pageTitle}</Shiitake>
        </Typography>
      </div>
    </Box>
  );
}
